import { Pipe, PipeTransform } from '@angular/core';

import { StateService } from '../state/state.service';

@Pipe({
  name: 'feature',
  standalone: false,
})
export class FeaturePipe implements PipeTransform {
  constructor(private state: StateService) {}
  transform(flag: string): boolean {
    return this.state.get('featureFlags')?.[flag] ?? false;
  }
}
